import React from 'react'
import { createRoot } from 'react-dom/client'
// import * as serviceWorker from './serviceWorker';
import { BrowserRouter, useNavigate } from 'react-router-dom'
import createStore from './store/createStore'
import { Provider } from 'react-redux'
import 'antd/dist/reset.css'
import AppRoutes from './routes'
import {apiUtils} from 'app/services'
import intl from 'react-intl-universal'
import { SUPPOER_LOCALES, localeIndex } from 'app/constants'
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import { setNavigate } from 'app/routerActions'
import SessionTimeOut from 'components/views/SessionTimeOut'

const MOUNT_ELEMENT = document.getElementById('root')
const root = createRoot(MOUNT_ELEMENT)

if (process.env.NODE_ENV == 'production') {
  // 添加sentry错误监听
  // Raven.config('https://e8e35dd1a9af4f28b4e3483e5c32eae0@sentry.io/1269923').install()
}

const getCurrentUser = () => {
  try{
    var localUser = JSON.parse(localStorage.getItem('current_user'))
    var sessionUser = JSON.parse(sessionStorage.getItem('current_user'))

    return localUser || sessionUser || null
  }catch (e){
    apiUtils.removeCurrentUser()
  }
}

function initLocale(localeIndex) {
  const currentLocale = SUPPOER_LOCALES[localeIndex].value; // Determine user's locale here
  intl.init({
    currentLocale,
    locales: {
      [currentLocale]: require(`./locales/${currentLocale}.js`)
    }
  })
}

initLocale(localeIndex)

const currentUser = getCurrentUser() || {}
apiUtils.setCurrentUser(currentUser || {})
const initialState = {
  user: currentUser,
  entities: {
    cities: currentUser.cities,
    // locations: currentUser.locations,
    spaces: currentUser.spaces
  }
}
const store = createStore(initialState)

function NavigationBinder() {
  const navigate = useNavigate()
  setNavigate(navigate)
  return null
}

let render = (key = null) => {
  const App = (
    <Provider store={store}>
      <ConfigProvider locale={zhCN}>
        <BrowserRouter basename={process.env.BASENAME || ''}>
          <NavigationBinder />
          <AppRoutes />
          <SessionTimeOut />
        </BrowserRouter>
      </ConfigProvider>
    </Provider>
  )
  root.render(App)
}

render()

// serviceWorker.unregister();
